











import Vue, { PropOptions } from 'vue';

interface ProductSalesPageIncludedLessonsProps {
  value: PropOptions;
}

export default Vue.extend({
  name: 'ProductSalesPageIncludedLessons',
  props: {
    value: {
      type: Object as () => ProductSalesPageIncludedLessonsResponse,
    },
  } as ProductSalesPageIncludedLessonsProps,
  methods: {
    handleOnInput(key: string, value: any): void {
      const emitData = {
        ...this.value,
        [key]: value,
      };
      this.$emit('input', emitData);
    },
  },
});
